// src/pages/Resources/DocumentationPage.js
import React from 'react';
import { Container, Typography, Paper, Box, Divider, List, ListItem, ListItemIcon, ListItemText, Link } from '@mui/material';
import { Description, Code, CloudQueue, Security, IntegrationInstructions } from '@mui/icons-material';

const RENGIGS = {
  green: '#2E7D32',
  lightGreen: '#4CAF50',
  lime: '#CDDC39',
  dark: '#1A2A3A',
  light: '#F8FAFC',
  border: '#E1E9F0',
  gradient: 'linear-gradient(135deg, #2E7D32 0%, #4CAF50 40%, #8BC34A 70%, #CDDC39 100%)',
};

const DocumentationPage = () => {
  return (
    <Container maxWidth="lg" sx={{ py: 6 }}>
      <Paper elevation={0} sx={{ p: { xs: 3, md: 5 }, borderRadius: 3, border: `1px solid ${RENGIGS.border}` }}>
        <Typography variant="h3" sx={{ fontWeight: 900, color: RENGIGS.dark, mb: 1 }}>
          Documentation
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 4 }}>
          Complete guides for using the Rengigs platform.
        </Typography>
        <Divider sx={{ mb: 4 }} />

        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 3 }}>
          <Description sx={{ fontSize: 40, color: RENGIGS.green }} />
          <Typography variant="h5" sx={{ fontWeight: 800, color: RENGIGS.green }}>Getting Started</Typography>
        </Box>
        <List>
          <ListItem>
            <ListItemIcon><IntegrationInstructions sx={{ color: RENGIGS.green }} /></ListItemIcon>
            <ListItemText primary="For Organizations" secondary="How to post problems, receive tagged solutions, and manage bids." />
          </ListItem>
          <ListItem>
            <ListItemIcon><IntegrationInstructions sx={{ color: RENGIGS.green }} /></ListItemIcon>
            <ListItemText primary="For Suppliers" secondary="How to list solutions, tag problems, and track engagement." />
          </ListItem>
          <ListItem>
            <ListItemIcon><IntegrationInstructions sx={{ color: RENGIGS.green }} /></ListItemIcon>
            <ListItemText primary="Account Management" secondary="Profile settings, organizations, and subscription management." />
          </ListItem>
        </List>

        <Divider sx={{ my: 4 }} />

        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 3 }}>
          <Code sx={{ fontSize: 40, color: RENGIGS.green }} />
          <Typography variant="h5" sx={{ fontWeight: 800, color: RENGIGS.green }}>API Reference</Typography>
        </Box>
        <Typography variant="body1" paragraph>
          Our REST API allows you to integrate Rengigs with your own systems. All endpoints are documented in our developer portal.
        </Typography>
        <Link href="/api" sx={{ color: RENGIGS.green }}>View API Documentation →</Link>

        <Divider sx={{ my: 4 }} />

        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 3 }}>
          <Security sx={{ fontSize: 40, color: RENGIGS.green }} />
          <Typography variant="h5" sx={{ fontWeight: 800, color: RENGIGS.green }}>Security & Best Practices</Typography>
        </Box>
        <Typography variant="body1" paragraph>
          Learn how we protect your data and how to keep your account secure.
        </Typography>
        <Link href="/security" sx={{ color: RENGIGS.green }}>Read our Security Overview →</Link>
      </Paper>
    </Container>
  );
};

export default DocumentationPage;